import { defineStore } from 'pinia';
import type { FilterModel, OptionsModel } from '../services/WebsitesService';

export const useWebsitesStore = defineStore('cms-websites', () =>
{
    const options = reactive<OptionsModel[]>([]);
    const current = reactive<CurrentWebsite>({
        website: null,
        locale: null
    });
    const columns = reactive<Columns>({
        visible: {},
        positions: {}
    });
    const filter = reactive(Form.create<FilterModel>({
        name: '',
        title: '',
        theme: '',
        isActive: null,
        isDefault: false
    }));
    const pager = reactive(new Pager(1, 20, 'Name', 'ASC'));

    return { options, current, columns, filter, pager };
});
